namespace GeniuzPOS.AdvPromo {
    export interface AdvancedPromoReportPrintData extends Serenity.ListRequest {
        PmId?: string;
        Header?: AdvancedPromoReportRow;
        Details?: Adv05ItemDetailsRow[];
        ExDetails?: Adv05ItemExDTsRow[];
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
